// extracted by mini-css-extract-plugin
module.exports = {"socialMediaLinks":"SocialMediaIcons_socialMediaLinks__Z1O9P"};